module.exports = __webpack_public_path__ + "img/bg2.097a198d.png";